import { EventBus } from '../../main'
import { API } from '../../services/api'

const state = () => ({
  jobs: [],
})

const getters = {
  jobList: (state) => {
    return state.jobs
  },
}

const actions = {
  async getJobs({ commit }) {
    try {
      const res = await API.get('/api/job/')
      commit('ChangeJobList', res.data)
    } catch (err) {
      EventBus.$emit('systemNotification', 'Something went wrong 🤔')
    }
  },
  async createJob ({ commit }, job) {
    try{
      const res = await API.post('/api/job/create', {job})
      commit('ChangeJobList', res.data)
      EventBus.$emit('systemNotification', 'Created job successfully!')
    } catch(err) {
      console.log(err);
      EventBus.$emit('systemNotification', 'Something went wrong 🤔')
    }
  },
  async updateJob ({ commit }, job) {
    try{
      const res = await API.post('/api/job/update', {job})
      commit('ChangeJobList', res.data)
      EventBus.$emit('systemNotification', 'Updated job successfully!')
    } catch(err) {
      console.log(err);
      EventBus.$emit('systemNotification', 'Something went wrong 🤔')
    }
  },
  async deleteJob ({ commit }, id) {
    try{
      const res = await API.post('/api/job/delete', {id})
      commit('ChangeJobList', res.data)
      EventBus.$emit('systemNotification', 'Deleted job!')
    } catch(err) {
      console.log(err);
      EventBus.$emit('systemNotification', 'Something went wrong 🤔')
    }
  },
  async acceptJob ({ commit }, job) {
    try{
      const res = await API.post('/api/job/accept', {job})
      commit('ChangeJobList', res.data)
      EventBus.$emit('systemNotification', 'Accepted job!')
    } catch(err) {
      console.log(err);
      EventBus.$emit('systemNotification', 'Something went wrong 🤔')
    }
  },
  async finishJob ({ commit }, job) {
    try{
      const res = await API.post('/api/job/finish', {job})
      commit('ChangeJobList', res.data)
      EventBus.$emit('systemNotification', 'Finished job!')
    } catch(err) {
      console.log(err);
      EventBus.$emit('systemNotification', 'Something went wrong 🤔')
    }
  },
  async closeJob ({ commit }, job) {
    try{
      const res = await API.post('/api/job/close', {job})
      commit('ChangeJobList', res.data)
      EventBus.$emit('systemNotification', 'Closed job!')
    } catch(err) {
      console.log(err);
      EventBus.$emit('systemNotification', 'Something went wrong 🤔')
    }
  },
  async rejectJob ({ commit }, job) {
    try{
      const res = await API.post('/api/job/reject', {job})
      EventBus.$emit('systemNotification', 'Rejected job!')
      commit('ChangeJobList', res.data)
    } catch(err) {
      console.log(err);
      EventBus.$emit('systemNotification', 'Something went wrong 🤔')
    }
  },
}

const mutations = {
  ChangeJobList(state, data) {
    state.jobs = data
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
